import { useState } from 'react';

export function SiteAdminUserDetailCourses(props: any) {
  const { user } = props;
  const [showCourses, setShowCourses] = useState(false);

  return (
    <>
      <h2>
        <a
          href="#"
          className="alt-button"
          onClick={(e) => {
            e.preventDefault();
            setShowCourses(!showCourses);
          }}
        >
          <span>
            {showCourses ? '-' : '+'} Courses ({user.courseUsers.length})
          </span>
        </a>
      </h2>
      {showCourses && (
        <article>
          <div>
            <table style={{ textAlign: 'left' }}>
              <thead>
                <tr>
                  <th scope="col">Course ID</th>
                  <th scope="col">Course Name</th>
                  <th scope="col">User Status</th>
                  <th scope="col">Partner</th>
                  <th scope="col">Type</th>
                  <th scope="col">Payment Required?</th>
                  <th scope="col">Enrolled</th>
                  <th scope="col">Enrollment Method</th>
                  <th scope="col">Unenrolled</th>
                </tr>
              </thead>
              <tbody>
                {user.courseUsers.map((courseUser) => (
                  <tr key={courseUser.id}>
                    <td>
                      <a href={`/app/nav/courses/${courseUser.courseId}`} target="_blank" rel="noopener noreferrer">
                        {courseUser.courseId}
                      </a>
                    </td>
                    <td>{courseUser.course?.name}</td>
                    <td>{courseUser.isAdmin ? 'Instructor' : 'Student'}</td>
                    <td>{courseUser.course?.partner.name}</td>
                    <td>{courseUser.course?.partner.accountType}</td>
                    <td>{courseUser.paymentRequired ? 'Yes' : 'No'}</td>
                    <td>{courseUser.createdAt}</td>
                    <td>{courseUser.enrolledVia}</td>
                    <td>{courseUser.deletedAt || 'N/A'}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </article>
      )}
    </>
  );
}
